import { EventHandler } from './types'

export const emptyMethod = () => {
	// void
}

export const createEventHandlers = <T = undefined>() => {
	let handlers: Array<EventHandler<T>> = []

	return {
		addListener: (handler: EventHandler<T>) => {
			handlers = [...handlers, handler]
		},
		removeListener: (handler: EventHandler<T>) => {
			handlers = handlers.filter((entry) => entry !== handler)
		},
		emit: (arg: T) => {
			handlers.forEach((entry) => entry(arg))
		},
	}
}
